<sh-form-group
  [invalid]="isControlInvalid$ | async"
  [required]="isControlRequired$ | async"
  [label]="label"
  [labelIcons]="labelIcons"
  [helpText]="helpText"
  [currentActionItems]="currentActionItems"
  [labelActionItems]="labelActions$ | async"
  [describeLabelId]="describeLabelId"
  [errorMsg]="errorMsg"
  [id]="controlId"
  [formGroupStyling]="formGroupStyling"
  >
  <div slot="inputPrefix">
    <ng-content></ng-content>
  </div>

  @if (canBeIndeterminate) {
    <sh-form-four-state-checkbox-complex-base
      [formControl]="control"
      [label]="label"
      [id]="controlId"
      [required]="isControlRequired$ | async"
      [attr.aria-describedBy]="(isControlInvalid$ | async) ? this.describeLabelId : null"
      [invalid]="isControlInvalid$ | async"
      [title]="control.disabled ? disabledMsg : ''"
      >
    </sh-form-four-state-checkbox-complex-base>
  } @else {
    <sh-form-four-state-checkbox-base
      [formControl]="control"
      [label]="label"
      [id]="controlId"
      [required]="isControlRequired$ | async"
      [attr.aria-describedBy]="(isControlInvalid$ | async) ? this.describeLabelId : null"
      [invalid]="isControlInvalid$ | async"
      [title]="control.disabled ? disabledMsg : ''"
      >
    </sh-form-four-state-checkbox-base>
  }


</sh-form-group>
